import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import CommonPage from "../common/CommonPage";
import { useGetProfile } from '../../../hooks/profile/useGetProfile';

const PrivacyPolicyPage = () => {
    const profile = useGetProfile();

    return (
        <CommonPage>

        <h1>Privacy Policy for Now & Here service</h1>
        <p><strong>Last Updated:</strong> 3 september 2025</p>
   
        <section>
            <p>This Privacy Policy describes how "Now & Here" ("we," "our," or "us") collects, uses, and shares your information when you use our mobile application [Your App Name] (the "App").</p>
            <p>By downloading, installing, and using the App, you agree to the collection and use of your information as described in this policy. If you do not agree, please do not install or use the App.</p>
            <p>The App and its services are provided on an "as is" and "as available" basis without any warranties of any kind. While we strive to provide a reliable service, we do not guarantee that the App will be error-free or uninterrupted. Technical issues, bugs, or service interruptions may occur from time to time, and we will make reasonable efforts to address them promptly.</p>

            <p>You are solely responsible for your use of our service and any content you create, upload, or share through the App. You acknowledge that you use the App at your own risk and that we shall not be held liable for any damages or losses resulting from your use of, or inability to use, the App or its services.</p>

            <p>We reserve the right to modify, suspend, or discontinue any aspect of the App at any time without prior notice. Continued use of the App after any changes constitutes acceptance of the modified terms.</p>

        </section>
        
        <section>
            <h2>1. Information We Collect</h2>
            <p>We collect the following types of information to provide and improve our services:</p>
            
            <h3>a. Personal Information:</h3>
            <p>Account Information: When you create an account, we collect your email address, login credentials (username and password), and any other information you provide.</p>
            <p>Location Data (GPS): With your explicit permission, we collect precise real-time and background location data from your device's GPS. This is a core function of our App.</p>
            
            <h3>b. User Content:</h3>
            <p>Videos: We collect and store the videos you record, upload, and submit through the App.</p>
            
            <h3>c. Automatically Collected Information:</h3>
            <p>Usage Data: We may collect data on how you interact with the App (e.g., features used, time spent, buttons clicked).</p>
        </section>
        
        <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect for the following purposes:</p>
            
            <ul>
                <li>To associate the videos you record with specific points on a map.</li>
                <li>To determine your location and offer you more relevant video content and tasks.</li>
                <li>To determine which tasks the application can offer you based on your geographic location.</li>
                <li>To create, maintain, and secure your user account.</li>
                <li>To operate, maintain, and improve the App's features and services.</li>
                <li>To communicate with you about your account, updates, or security alerts.</li>
            </ul>
        </section>
        
        <section>
            <h2>3. Sharing Your Information with Third Parties</h2>
            <p>We may share the information we collect with third-party companies in the following circumstances:</p>
            
            <p>Service Providers: We share data with trusted third-party vendors who perform services on our behalf, such as cloud storage providers (e.g., AWS, Google Cloud), data analytics services, customer support platforms, and marketing partners. These parties are contractually obligated to handle your data securely and only for the purposes we specify.</p>
            
            <p>Legal Requirements: We may disclose your information if required to do so by law or in response to valid legal requests by public authorities (e.g., a court or government agency).</p>
            
            <p>Business Transfers: In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred to the new owner.</p>
            
            <p>The data shared may include your GPS location, email, login information, and videos you have recorded.</p>
        </section>
        
        <section>
            <h2>4. Data Storage and Security</h2>
            <p>We implement industry-standard administrative, technical, and physical security measures to protect your personal information. However, no method of electronic transmission or storage is 100% secure. While we strive to protect your data, we cannot guarantee its absolute security.</p>
            
            <p>Your videos and personal data are stored on our secure servers and with our third-party service providers.</p>
        </section>
        
        <section>
            <h2>5. User Content and Ownership</h2>
            
            <h3>a. Prohibited Content:</h3>
            <p>You are strictly prohibited from recording, uploading, or sharing any video content that contains:</p>
            
            <ul>
                <li>Pornography or sexually explicit material.</li>
                <li>Graphic violence, blood, or gore.</li>
                <li>Threats or calls for violence against individuals or groups.</li>
                <li>Hate speech, racism, or content that offends the feelings of believers.</li>
                <li>Infringement of any third-party copyright or intellectual property.</li>
                <li>Any other content that is illegal, harassing, defamatory, or harmful to others.</li>
            </ul>
            
            <h3>b. Ownership of Content:</h3>
            <p>All videos recorded and submitted through the Application become the property of "Now & Here". By submitting content, you grant us a perpetual, worldwide, royalty-free license to use, host, store, reproduce, modify, and display that content.</p>
            
            <h3>c. Enforcement:</h3>
            <p>We reserve the right to review all user content. In case of any violation of these rules, we reserve the right to immediately and permanently block your user account without prior warning. We may also report illegal content to the appropriate law enforcement authorities.</p>
        </section>
        
        <section>
            <h2>6. Your Choices and Controls</h2>
            <p>Location Services: You can enable or disable location services at any time through your device settings. Please note that disabling location services will prevent the core features of the App from functioning correctly.</p>
            
            <p>Account Information: You can review and update your account information (like your email) within the App's settings.</p>
        </section>
        
        <section>
            <h2>7. Children's Privacy</h2>
            <p>Our App is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we learn we have collected such information, we will delete it immediately.</p>
        </section>
        
        <section>
            <h2>8. Changes to This Privacy Policy</h2>
            <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last Updated" date. You are advised to review this policy periodically for any changes.</p>
        </section>
        
        <section>
            <h2>9. Contact Us</h2>
            <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
            <p>Telegram: @cromlehg</p>
            <p>Email: cromlehg@gmail.com</p>
            <p>Website: https://nowahere.com</p>
        </section>

        </CommonPage>
    );
}

export default PrivacyPolicyPage;